import Axios, { InternalAxiosRequestConfig } from 'axios'
import { getAccessTokenFromResfreshToken } from 'utils/getAccessToken'

async function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = await getToken()

  if (token && config && config.headers) {
    config.headers.authorization = `Bearer ${token}`
  }

  if (config.headers) {
    config.headers.Accept = 'application/json'
    config.withCredentials = false
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    } else {
      config.headers['Content-Type'] = 'application/json';
    }
  }

  return config
}

export const axios = Axios.create({
  baseURL: `${process.env.REACT_APP_VERACITY_LAB_API_BASE_URL}`,
})

axios.interceptors.request.use(authRequestInterceptor)
axios.interceptors.response.use((response) => {
  return response
}, async (error) => {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    try {
      const token = await getAccessTokenFromResfreshToken()

      // Retry the original request with the new token
      originalRequest.headers.Authorization = `Bearer ${token}`;
      return axios(originalRequest);
    } catch (error) {
      // Handle refresh token error or redirect to login
      window.location.href = process.env.REACT_APP_LOGIN_URL ?? '/login'
    }
  }
  return Promise.reject(error)
},
)

export const getToken = async () => {
  const token = localStorage.getItem('access_token')
  return token
}
